import { useMemo } from 'react';

import { Dashboard } from '@sternum/web/features/dashboard/models';
import { trpc, TRPCReactQueryOptions, TRPCRouterInputs } from '@sternum/web/services/trpc';

type GetDashboardRequest = TRPCRouterInputs['dashboard']['getDashboard'];
type UseDashboardOptions = TRPCReactQueryOptions['dashboard']['getDashboard'];

export function useSingleDashboard(request: GetDashboardRequest, options: UseDashboardOptions = {}) {
  const { data, ...rest } = trpc.dashboard.getDashboard.useQuery(request, options);

  const dashboard = useMemo(() => {
    return data
      ? {
          ...data,
          createdAt: new Date(data.createdAt),
          updatedAt: new Date(data.updatedAt),
          widgets: data.widgets as Dashboard['widgets'],
        }
      : undefined;
  }, [data]);

  return { dashboard, ...rest };
}
